import Column from '@components/Column';
import Image from '@components/Image';
import Indicator from '@components/Indicator';
import { GiftItemType } from '@models/gift';
import { useFlow } from '@stackflow/react';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';

import img from './img.png';
import styles from './styles.module.scss';

interface Props {
  type: 'GIFT' | 'BUY';
}

function NewCards({ type }:Props) {
    const cards = [img, img, img, img, img];
    const [index, setIndex] = useState<number>(0);
    const settings = {
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        speed: 400,
        swipe: true,
        swipeToSlide: true,
        easing: 'ease-out',
        variableWidth: true,
        centerMode: true,
        centerPadding: '30px',
        afterChange: setIndex,
    };
    const isGift = type === 'GIFT';
    const ref = useRef<Slider>(null);
    const { push } = useFlow();
    useEffect(() => {
        const interval = setInterval(() => {
            ref.current?.slickNext();
        }, 2000);
        return () => {
            clearInterval(interval);
        };
    }, [ref]);

    return (
        <Column className={styles.container}
            align='center'>
            {/*
            <Slider {...settings}
                    ref={ref} >
                {cards.map((card, i) => {
                  const handleClick = () => {
                    if (isGift) {
                      push('GiftOrderActivity', {
                        giftItemId: i.toString(),
                        type: GiftItemType.CASH,
                        qty: 1,
                      });
                    } else {
                      push('PrepaidCardImageActivity', { prepaidCardImageId: 'test' });
                    }
                  };
                  return (
                        <div className={styles.cardWrapper}
                             key={i.toString()}>
                            <div onClick={handleClick} >
                                <Image src={card}
                                       className={styles.image}
                                       alt=''
                                       width={184}
                                       height={120} />
                            </div>
                        </div>
                  );
                })}
            </Slider>
            <Indicator total={cards.length} current={index}/>
            */}
        </Column>
    );
}

export default NewCards;
